import { FC, ChangeEvent } from 'react';
import { Popover, PopoverProps, Radio, RadioGroup, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Done from '@mui/icons-material/Done';
import { OOD_COLORS_LIST } from '../types/colors';
import getOodColor from '../utils/getOodColor';

type Props = Readonly<{
	open: boolean;
	anchorEl: PopoverProps['anchorEl'];
	defaultValue?: string | null;
	onClose: () => void;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}>;

export const ColorPicker: FC<Props> = ({ open, anchorEl, defaultValue, onClose, onChange }) => {
	const theme = useTheme();

	return (
		<Popover
			id={'colorpicker-popover'}
			open={open}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'center',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'center',
				horizontal: 'left',
			}}
			onClose={onClose}
		>
			<RadioGroup
				value={defaultValue}
				name={'radio-buttons-color'}
				sx={{ display: 'grid', gap: theme.spacing(0.6), gridTemplateColumns: 'repeat(3, 1fr);', margin: theme.spacing(0.6) }}
				onChange={onChange}
			>
				{OOD_COLORS_LIST.map((color) => (
					<Radio
						key={color}
						id={color}
						icon={<span />}
						checkedIcon={<Done fontSize={'small'} sx={{ color: theme.palette.common.white }} />}
						value={color}
						sx={{
							'&.MuiButtonBase-root': {
								width: theme.spacing(4),
								height: theme.spacing(4),
								backgroundColor: getOodColor(theme, color).content,
								borderRadius: '5px',
							},
						}}
					/>
				))}
				<Radio
					id={'none'}
					icon={<CloseIcon sx={{ color: (theme) => theme.palette.dustred[400] }} />}
					checkedIcon={<CloseIcon sx={{ color: (theme) => theme.palette.dustred[400] }} />}
					value={null}
					sx={{
						'&.MuiButtonBase-root': {
							width: theme.spacing(4),
							height: theme.spacing(4),
							backgroundColor: (theme) => theme.palette.grey[700],
							borderRadius: '5px',
						},
					}}
				/>
			</RadioGroup>
		</Popover>
	);
};
